module.exports = __webpack_public_path__ + "static/img/MONITORS.0e571bb9.png";